export default (settings: Record<string, any>) => {
  if (!settings.common) return
  const commonSettings = settings.common
  if (commonSettings['grid_show_extra_columns'] !== undefined) {
    commonSettings['grid-show-extra-columns'] = commonSettings['grid_show_extra_columns']
    delete commonSettings['grid_show_extra_columns']
  }
  if (commonSettings['analytics_debug_tab'] !== undefined) {
    commonSettings['analytics-debug-tab'] = commonSettings['analytics_debug_tab']
    delete commonSettings['analytics_debug_tab']
  }
  if (commonSettings['ai_agent'] !== undefined) {
    commonSettings['ai-agent'] = commonSettings['ai_agent']
    delete commonSettings['ai_agent']
  }
}
